export default "__VITE_ASSET__ej3Fx7ee__"